import { RGBA } from "./rgba";

const harborGrey = [190, 190, 190, 1];

export const styleSchema = {
  cube: {
    faceFill: "rgb(160,160,160)",
    faceStroke: "rgb(230,230,230)",
  },
  towerFace: {
    fill: RGBA.build(harborGrey),
    stroke: "rgb(230,230,230)",
    strokeWidth: 2,
  },
  towerPaddingPerc: {
    h: 13 / 460,
    top: 38 / 1000,
    bottom: 100 / 1000,
  },
  locker: {
    opacityForDefaultBgImg: -0.4,
    opacityForBgImg: -0.15,
    default: {
      strokeWidth: 3,
      strokeColor: "rgb(145,145,145)",
      textColor: "black",
      iconColor: "blue",
    },
    backgroundByAccess: {
      default: { fill: "rgb(135, 206, 250)" },
      1: { fill: RGBA.build(harborGrey) },
      2: { fill: "rgb(255, 228, 196)" },
      3: { fill: "rgb(233, 150, 122)" },
    },
    oos: { fill: "rgb(219, 112, 147)" },
    highlight: {
      strokeWidth: 3,
      textColor: "white",
      iconColor: "white",
    },
    activeShield: {
      opacity: 0.1,
      textOpacity: 0.1,
    },
    prettyBorder: {
      h1: { stroke: "rgb(145,145,145)", strokeWidth: 3 },
      h2: { stroke: "rgb(90,90,90)", strokeWidth: 3 },
      h3: { stroke: "rgb(242,242,242)", strokeWidth: 1 },
      v1: { stroke: "rgb(212,212,212)", strokeWidth: 1 },
    },
    freeSpace: {
      label: "Available",
      fill: "grey",
    },
  },
  iconPadding: 4,
  labeledArrow: {
    pointerLength: 5,
    pointerWidth: 5,
  },
};
